/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Typed LiveKit room location for a booking (API mirror of service enum).
 */
export type OralExamPresenceLocation = (typeof OralExamPresenceLocation)[keyof typeof OralExamPresenceLocation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamPresenceLocation = {
  preflight: 'preflight',
  exam: 'exam',
  none: 'none',
  unknown: 'unknown',
} as const;
